module.exports = __webpack_public_path__ + "static/media/21.e7acb4ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/21.svg
// module id = 394
// module chunks = 14